import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import DesignA from "./pages/DesignA";
import DesignB from "./pages/DesignB";
import DesignC from "./pages/DesignC";
import GalleryPage from "./pages/GalleryPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/design-a" element={<DesignA />} />
        <Route path="/design-b" element={<DesignB />} />
        <Route path="/design-c" element={<DesignC />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
